// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ugiu","right":"styles_right__1FHQv"};